<script lang="ts">
    import { gameManager } from "../../Phaser/Game/GameManager";
    import { triggerClickOnEnterOrSpace } from "../../Utils/svelte-a11y";
    import { mediaSettingsOpenStore } from "../../Stores/MenuStore";
    import {
        myMicrophoneStore,
        proximityMeetingStore,
        inExternalServiceStore,
        myCameraStore,
    } from "../../Stores/MyMediaStore";
    import { screenSharingAvailableStore } from "../../Stores/ScreenSharingStore";
    import { isInRemoteConversation } from "../../Stores/StreamableCollectionStore";
    import MediaSettingsList from "./MediaSettingsList/MediaSettingsList.svelte";
    import CameraMenuItem from "./MenuIcons/CameraMenuItem.svelte";
    import ChatMenuItem from "./MenuIcons/ChatMenuItem.svelte";
    import ContextualMenuItems from "./MenuIcons/ContextualMenuItems.svelte";
    import InviteMenuItem from "./MenuIcons/InviteMenuItem.svelte";
    import MicrophoneMenuItem from "./MenuIcons/MicrophoneMenuItem.svelte";
    import PictureInPictureMenuItem from "./MenuIcons/PictureInPictureMenuItem.svelte";
    import ScreenSharingMenuItem from "./MenuIcons/ScreenSharingMenuItem.svelte";
    import { IconChevronUp } from "@wa-icons";

    let smallArrowVisible = true;

    const gameScene = gameManager.getCurrentGameScene();
    const showChatButton = gameScene.room.isChatEnabled;
</script>

<div
    data-testid="bottom-action-bar"
    class="@container/actions w-full transition-all pointer-events-none hidden @[160px]/main-layout:block"
>
    <div class="flex justify-center relative mb-2 @md/main-layout:mb-2 @xl/main-layout:mb-6">
        <div class="flex gap-2 @sm/main-layout:gap-3 relative group/hardware">
            {#if !$inExternalServiceStore && $proximityMeetingStore && $myMicrophoneStore}
                <MicrophoneMenuItem />
            {/if}
            {#if smallArrowVisible}
                <div
                    class="absolute h-6 w-7 rounded-t inset-s-[34px] @sm/main-layout:inset-s-[40px] m-auto p-1 z-10 transition-all -top-3 hidden
                    opacity-0 sm:block mobile:block mobile:opacity-100 pointer-events-auto
                    {$mediaSettingsOpenStore ? 'opacity-100' : 'group-hover/hardware:opacity-100'}"
                >
                    <div
                        data-testid="media-settings-toggle"
                        class="absolute top-0 inset-s-0 inset-e-0 m-auto hover:bg-mdark/20 h-5 w-5 flex items-center justify-center rounded-sm"
                        role="button"
                        tabindex="0"
                        aria-expanded={$mediaSettingsOpenStore}
                        onclick={(event) => {
                            event.stopPropagation();
                            event.preventDefault();
                            mediaSettingsOpenStore.set(!$mediaSettingsOpenStore);
                        }}
                        onkeydown={triggerClickOnEnterOrSpace}
                        aria-label="Открыть/закрыть настройки медиа"
                    >
                        <IconChevronUp
                            stroke-width={2}
                            class="aspect-square transition-all select-none text-mdarkd {$mediaSettingsOpenStore
                                ? ''
                                : 'rotate-180'}"
                        />
                    </div>
                </div>
            {/if}
            {#if $mediaSettingsOpenStore}
                <MediaSettingsList onclose={() => mediaSettingsOpenStore.set(false)} />
            {/if}
            {#if !$inExternalServiceStore && $myCameraStore}
                <CameraMenuItem />
            {/if}
            {#if $screenSharingAvailableStore}
                <ScreenSharingMenuItem />
            {/if}
            {#if $isInRemoteConversation}
                <PictureInPictureMenuItem />
            {/if}
            <div class="hidden @sm/actions:flex items-center gap-3">
                <ContextualMenuItems />
            </div>
            <ChatMenuItem chatEnabledInAdmin={showChatButton} />
        </div>
        <div
            class="gap-3 absolute right-1 @md/main-layout:right-2 @xl/main-layout:right-6 narrow:hidden hidden @[240px]/main-layout:flex"
        >
            <InviteMenuItem />
        </div>
    </div>
</div>
